import React from 'react';
import classNames from 'classnames';

import { getElementTemplateExampleLink } from '../../../../common/templates/templateUtil';

import { ImMNElement } from '../../../../common/elements/elementModelTypes';

import './BoardTemplatePickerPublicParentPopup.scss';

type Props = {
    className?: string;
    currentBoard: ImMNElement;
};

const BoardTemplatePickerPublicParentPopup = ({ className, currentBoard }: Props) => (
    <div className={classNames(className, 'BoardTemplatePickerPublicParentPopup')}>
        <div className="DesktopBoardTemplatePickerPopupContent">
            <h3>Public template</h3>

            <label>Template id (for Prismic):</label>
            <input className="FormInput template-id" value={getElementTemplateExampleLink(currentBoard)} readOnly />
        </div>
    </div>
);

export default BoardTemplatePickerPublicParentPopup;
